import { Avatar, AvatarProps } from '../Avatar';

const ZERO_EX = 'zeroxv2';

export type BridgeAvatarProps = Omit<AvatarProps, 'rounded'> & {
  /**
   * Name of the bridge to display the logo for.
   */
  name: string;
};

const bridgeAvatarRadius = '32%';

/**
 * A data structure mapping bridge protocol names to their logo image filenames.
 */
const bridgeIcons: Record<string, string> = {
  'across': 'across.png',
  'across_v4': 'across.png',
  'arbitrum-bridge': 'arbitrum.png',
  'arbitrum_bridge': 'arbitrum.png',
  'anyswap-router-v4': 'anyswap.png',
  'anyswap-router-v6': 'anyswap.png',
  'base-bridge': 'base.png',
  'connext': 'connext.png',
  'hop': 'hop.png',
  'refuel-bridge': 'refuel.png',
  'stargate': 'stargate.png',
  'stargate-v2': 'stargate.png',
  'symbiosis': 'symbiosis.jpg',
  'polygon-bridge': 'polygon.png',
  'hyphen': 'hyphen.svg',
  'celer': 'celer.png',
  'cctp': 'cctp.svg',
  'cctp-v2': 'cctp.svg',
  'circle_forwarder_standard': 'cctp.svg',
  'circle_forwarder_fast': 'cctp.svg',
  'optimism-bridge': 'optimism.png',
  'synapse': 'synapse.png',
  'zksync-native': 'zksync.svg',
  'zora-bridge': 'zora.png',
  'scroll-native-bridge': 'scroll.svg',
  'mantle-native-bridge': 'mantle.svg',
  'mode-native-bridge': 'mode.svg',
  'mayan': 'mayan.png',
  'mayan_swift': 'mayan.png',
  'mayan_mctp': 'mayan.png',
  'mayan_fast_mctp': 'mayan.png',
  'linea': 'linea.svg',
  'near_intents': 'near.png',
  'relay': 'relay.png',
  'gaszip': 'gaszip.png',
  'gas.zip': 'gaszip.png',
  'gas_zip': 'gaszip.png',
  'squid': 'squid.png',
  'squid_coral': 'squid.png',
};

export const BridgeAvatar = (props: BridgeAvatarProps) => {
  const { name, size = 20, ...otherProps } = props;

  const bridgeSrc = bridgeIcons[name] ? `/images/bridges/${bridgeIcons[name]}` : undefined;
  const processedBridgeSrc = name === ZERO_EX ? '/images/liquidity-providers/0x.png' : bridgeSrc;

  return (
    <Avatar
      src={processedBridgeSrc}
      alt={`${name} logo`}
      fallbackSrc="/images/chains/none.svg"
      radius={bridgeAvatarRadius}
      size={size}
      {...otherProps}
    />
  );
};
